import videojs from 'video.js';

document.addEventListener('DOMContentLoaded', function () {
    const videoElements = document.querySelectorAll('.video-js');

    videoElements.forEach(function (element) {
        const playerId = element.id || ('video-player-' + Math.random().toString(36).substr(2, 9));

        if (!element.id) {
            element.id = playerId;
        }

        if (typeof window === 'undefined') {
            return;
        }

        const player = videojs(playerId, {
            controls: true,
            preload: element.getAttribute('preload') || 'none',
            fluid: true,
            responsive: true,
            aspectRatio: '16:9',
            html5: {
                vhs: {
                    overrideNative: true,
                },
            },
            controlBar: {
                pictureInPictureToggle: false,
            },
            userActions: {
                hotkeys: true,
            },
        });

        player.ready(function () {
            const descriptionId = element.getAttribute('aria-describedby');
            if (descriptionId) {
                player.controlBar.el().setAttribute('aria-describedby', descriptionId);
            }
        });
    });
});
